var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#094","strokeWidth":"1.5","transform":"translate(1 1)"},[React.createElement("rect",{"width":"23.81","height":"1.19","rx":".595","key":0}),React.createElement("rect",{"width":"23.81","height":"1.19","y":"5.952","rx":".595","key":1}),React.createElement("rect",{"width":"23.81","height":"1.19","y":"11.905","rx":".595","key":2})]));
}

Hamburger.defaultProps = {"width":"26","height":"15","viewBox":"0 0 26 15"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
